import type { RichtextAdapterProps } from "modules/storyblok/adapters/RichtextAdapter";
import { contentStyles } from "modules/storyblok/adapters/Content";

export const textStyles: RichtextAdapterProps["customStyles"] = {
  ...contentStyles,
  heading: {
    ...contentStyles.heading,
    fontWeight: "bold",
    lineHeight: "short",
    mb: 2,
    mt: 0,
  },
  paragraph: { ...contentStyles.paragraph, fontSize: "md", lineHeight: "base" },
};
